import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { get } from 'lodash';
import { PAGE_SUB_TYPES, PAGE_TYPES } from '@sparefoot/tracking-events';

import withSearchHandler from 'decorators/withSearchHandler';
import './pspPage.scss';
import { Page } from 'components/core/Page';
import { PSPLayout } from 'components/organisms/PSPLayout';
import { ErrorPage as NewFourOhFourPage } from 'pages/ErrorPage/ErrorPage';
import withPageViewTracking from '../../components/core/library/tracking-utils/tracking/withPageViewTracking';
import { getPSPContent, normalizeKeyword } from 'pages/PSPPage/PSPContentMap';
import { getMetadata } from 'pages/PSPPage/utils/getMetadata';
import { pageTypes } from 'config/pageTypes';
import {
	buildReviewSchema,
	buildPageSchema,
	buildPSPUrl,
	PSP_PAGE_BY_KEY,
} from 'pages/PSPPage/utils/buildSchema';
import {
	buildSGPPageSchema,
	SGP_PAGE_BY_KEY,
} from 'pages/PSPPage/utils/buildSGPSchema';
import { PSPMeta } from 'pages/PSPPage/PSPMeta';

export const enhance = compose(
	withPageViewTracking((props) => {
		const keyword = get(props.match, 'params.keyword') || props.keyword;
		return (
			SGP_PAGE_BY_KEY[keyword] ||
			PSP_PAGE_BY_KEY[keyword] ||
			PAGE_TYPES.PSP
		);
	}),
	withSearchHandler,
);

export function PSPPage(props) {
	const { handleSearch } = props;
	const keywordParam = get(props.match, 'params.keyword') || props.keyword;
	const normalizedSlug = normalizeKeyword(keywordParam);
	const pageContent = getPSPContent(keywordParam);

	if (!normalizedSlug || !pageContent) {
		return <NewFourOhFourPage {...props} />;
	}

	const metadata = getMetadata(normalizedSlug, pageContent.pageType);
	const reviewSchema = buildReviewSchema(pageContent);

	const schema =
		pageContent.pageType === pageTypes.SGP
			? buildSGPPageSchema(keywordParam, pageContent, metadata)
			: buildPageSchema(
					keywordParam,
					normalizedSlug,
					pageContent.type,
					reviewSchema,
					metadata,
				);
	const pageSchema = JSON.stringify(schema);

	const canonicalUrl =
		pageContent.pageType === pageTypes.SGP
			? `https://www.selfstorage.com/self-storage-sizes/${keywordParam}/`
			: buildPSPUrl(keywordParam);

	return (
		<Page
			className="psp-page"
			pageType={PAGE_SUB_TYPES.STORAGE_LANDING}
		>
			<PSPMeta
				keyword={keywordParam}
				normalizedSlug={normalizedSlug}
				contentType={pageContent.pageType}
			/>
			<PSPLayout
				handleSearch={handleSearch}
				content={pageContent}
				pageSchema={pageSchema}
				pageType={pageContent.type}
				breadcrumbUrl={canonicalUrl}
			/>
		</Page>
	);
}

PSPPage.propTypes = {
	handleSearch: PropTypes.func.isRequired,
	match: PropTypes.object,
	keyword: PropTypes.string,
};

export default enhance(PSPPage);
